import { useAuth } from './auth'
import { useCanal } from './canal'
import { canaisPermitidos } from './permissoesCanal'

// True quando faz sentido mostrar a tag Loja×Online por linha: o usuário pode ver
// os DOIS canais E está na visão "Ambos" (ou seja, a mesma lista pode conter Loja
// e Online misturados). Quando trancado num canal, a tag é redundante → escondida.
// Feature 09/07 (isolamento por canal).
export function useMostrarCanalTag(): boolean {
  const { user } = useAuth()
  const { canalView } = useCanal()
  const { podeBalcao, podeOnline } = canaisPermitidos(user)
  return podeBalcao && podeOnline && canalView === 'ambos'
}
